import { render } from "./CompanyDescriptorsCell.vue?vue&type=template&id=607931c4"
import script from "./CompanyDescriptorsCell.vue?vue&type=script&lang=js"
export * from "./CompanyDescriptorsCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__